import React from "react";
import styled, { css } from "styled-components";
import { transparentize } from "polished";
import { useUserSettings } from "@americanbible/uikit";

const StyledScriptureContainer = styled.div`
  direction: ${({ scriptDirection = "ltr" }) => scriptDirection};
  padding-top: 6px;
  position: relative;
  color: ${props => props.theme.primaryText} !important;


  /* allows modification of font-size */
  font-size: ${({ fontSize }) => fontSize}px !important;

  ${({
    highlightSelectedVerse,
    theme: { hightlightColor, selectedColor, matchedColor }
  }) =>
    highlightSelectedVerse &&
    css`
      .verse-span {
        position: relative;
        cursor: pointer;
        transition: background-color 0.5s ease;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent; /* For some Androids */
      }
      .verse-span.highlighted {
        border-bottom: solid 1px ${hightlightColor};
      }
      .verse-span.selected {
        border-bottom: solid 1px ${selectedColor};
      }

      .verse-span.matched {
        animation: target-fade 5s 1;
      }

      @keyframes target-fade {
        0% {
          background-color: ${transparentize(1, matchedColor)};
        }
        30% {
          background-color: ${transparentize(0.6, matchedColor)};
        }
        100% {
          background-color: ${transparentize(1, matchedColor)};
        }
      }
    `}

  /* toggles display of verse numbers */
  ${({ showVerseNumbers }) =>
    !showVerseNumbers &&
    css`
      p .v {
        display: none;
      }
    `} 

  /* toggles display of footnootes */
  ${({ footnotes }) =>
    footnotes
      ? css`
          p .x,
          p .f {
            float: none;
            display: inline-block;
            clear: none;
            width: auto;
            vertical-align: super;
            margin: 0;
            text-align: left;
            border-left: none;
            border-right: none;
            padding: 0;
            text-indent: 0;
            background-color: transparent;
            outline: none;
          }
        `
      : css`
          p .x,
          p .f {
            display: none;
          }
        `};
`;

const ScriptureContainer = props => {
  const { fontSize, showVerseNumbers, showFootnotes } = useUserSettings();

  return (
    <StyledScriptureContainer
      {...props}
      footnotes={props.footnotes || showFootnotes}
      showVerseNumbers={showVerseNumbers}
      fontSize={fontSize}
    />
  );
};

export default ScriptureContainer;
